import { useContext, useMemo, useState } from "react";
import { PaginationQueryPackage } from "../../../../models/API/QueryParams/PaginationQueryPackage";
import {CombinedUserContact, ContactResponse} from "../../../../models/Contact";
import { LabelContextEnum } from "../../../../models/ContactLabel";
import { UserResponse } from "../../../../models/User";
import { ContactForm } from "../../../ContactsApi/ContactForm";
import { PermissionEnum } from "../../../Permission/PermissionEnum";
import { AbilityContext } from "../../../UserApi/logic/Can";
import { useGetAllUsersByOrganisationQuery } from "../../../UserApi/redux/userApiSlice";
import { HostingsiteResponse } from "../../../../models/Hostingsite";
import {
    useAddContactToHostingSiteMutation, useGetContactsByHostingSiteIdQuery,
    useGetExternalContactsByOrganisationIdQuery, useRemoveContactFromHostingSiteMutation
} from "../../../ContactsApi/redux/contactsApiSlice";
import {TextFieldRender} from "../../../../components/Forms/Renders/TextFieldRender";

interface ContactsTabProps {
    hostingSite: HostingsiteResponse
}

export default function ContactsTab(props: ContactsTabProps) {
    const ability = useContext(AbilityContext)
    const administratingOrganisation = props.hostingSite.administrating_organisation
    const ownerOrganisation = props.hostingSite.owner_organisation
    const sameOwnerAndAdministratingOrg = administratingOrganisation?.uuid == ownerOrganisation?.uuid

    const administratingUsers = useGetAllUsersByOrganisationQuery({
        pagination: new PaginationQueryPackage(),
        uuid: administratingOrganisation?.uuid
    }, { skip: !ability.can(PermissionEnum.HOSTING_SITE_WRITE, administratingOrganisation) });

    const ownerUsers = useGetAllUsersByOrganisationQuery({
        pagination: new PaginationQueryPackage(),
        uuid: ownerOrganisation?.uuid
    }, { skip: !ability.can(PermissionEnum.HOSTING_SITE_WRITE, ownerOrganisation) || sameOwnerAndAdministratingOrg });

    const administratingExternalContacts = useGetExternalContactsByOrganisationIdQuery({
        pagination: new PaginationQueryPackage(),
        uuid: administratingOrganisation?.uuid
    }, { skip: !ability.can(PermissionEnum.HOSTING_SITE_WRITE, administratingOrganisation) })

    const ownerExternalContacts = useGetExternalContactsByOrganisationIdQuery({
        pagination: new PaginationQueryPackage(),
        uuid: ownerOrganisation?.uuid
    }, { skip: !ability.can(PermissionEnum.HOSTING_SITE_WRITE, ownerOrganisation) || sameOwnerAndAdministratingOrg })

    const [allUsers, setAllUsers] = useState<UserResponse[]>([])
    const [allExternalContacts, setAllExternalContacts] = useState<ContactResponse[]>([])

    useMemo(() => {
        setAllUsers([...administratingUsers.data ?? [], ...ownerUsers.data ?? []])
    }, [administratingUsers.data, ownerUsers.data])

    useMemo(() => {
        setAllExternalContacts([...administratingExternalContacts.data ?? [], ...ownerExternalContacts.data ?? []])
    }, [administratingExternalContacts.data, ownerExternalContacts.data])

    return (
        <>
            {ownerOrganisation?.uuid &&
                <ContactForm
                    key={JSON.stringify(allUsers)}
                    additionalFieldRenders={(contact: CombinedUserContact) => [
                        new TextFieldRender({
                            displayText: "Phone",
                            fieldName: "",
                            nestedfieldName: "phone",
                            type: "text",
                            uniqueId: contact.uuid ?? ""
                        })
                    ]}
                    ownerOrganisationUuid={ownerOrganisation?.uuid}
                    administratingOrganisationUuid={administratingOrganisation?.uuid}
                    entityUuid={props.hostingSite.uuid!}
                    users={allUsers}
                    externalContacts={allExternalContacts}
                    useRemoveContactFromEntity={useRemoveContactFromHostingSiteMutation}
                    useAttachContact={useAddContactToHostingSiteMutation}
                    useGetContactsByEntityUuid={useGetContactsByHostingSiteIdQuery}
                    context={LabelContextEnum.HOSTINGSITE}
                />
            }
        </>
    )
}